import React from 'react';

const DragIcon = ({ size = 20, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M5.83337 15.4993C5.83337 16.416 6.58337 17.166 7.50004 17.166C8.41671 17.166 9.16671 16.416 9.16671 15.4993C9.16671 14.5827 8.41671 13.8327 7.50004 13.8327C6.58337 13.8327 5.83337 14.5827 5.83337 15.4993Z"
        fill="#1A0425"
      />
      <path
        d="M5.83337 10.4993C5.83337 11.416 6.58337 12.166 7.50004 12.166C8.41671 12.166 9.16671 11.416 9.16671 10.4993C9.16671 9.58268 8.41671 8.83268 7.50004 8.83268C6.58337 8.83268 5.83337 9.58268 5.83337 10.4993Z"
        fill="#1A0425"
      />
      <path
        d="M5.83337 5.49935C5.83337 6.41602 6.58337 7.16602 7.50004 7.16602C8.41671 7.16602 9.16671 6.41602 9.16671 5.49935C9.16671 4.58268 8.41671 3.83268 7.50004 3.83268C6.58337 3.83268 5.83337 4.58268 5.83337 5.49935Z"
        fill="#1A0425"
      />
      <path
        d="M10.8334 15.4993C10.8334 16.416 11.5834 17.166 12.5 17.166C13.4167 17.166 14.1667 16.416 14.1667 15.4993C14.1667 14.5827 13.4167 13.8327 12.5 13.8327C11.5834 13.8327 10.8334 14.5827 10.8334 15.4993Z"
        fill="#1A0425"
      />
      <path
        d="M10.8334 10.4993C10.8334 11.416 11.5834 12.166 12.5 12.166C13.4167 12.166 14.1667 11.416 14.1667 10.4993C14.1667 9.58268 13.4167 8.83268 12.5 8.83268C11.5834 8.83268 10.8334 9.58268 10.8334 10.4993Z"
        fill="#1A0425"
      />
      <path
        d="M10.8334 5.49935C10.8334 6.41602 11.5834 7.16602 12.5 7.16602C13.4167 7.16602 14.1667 6.41602 14.1667 5.49935C14.1667 4.58268 13.4167 3.83268 12.5 3.83268C11.5834 3.83268 10.8334 4.58268 10.8334 5.49935Z"
        fill="#1A0425"
      />
    </svg>
  );
};

export default DragIcon;
